import { render, staticRenderFns } from "./ServiceElementSelector.vue?vue&type=template&id=32109a0a"
import script from "./ServiceElementSelector.vue?vue&type=script&lang=ts"
export * from "./ServiceElementSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports